import { useTranslation } from "react-i18next";
import { Modal, Button } from "antd";
import InfinityTable from "../../infinity-table/infinity-table";
import moment from "moment";
import classNames from "classnames";
import "./styles.css";

const ChangeLogsModalComponent = ({
  title,
  handleCancel,
  isModalOpen,
  logs = [],
  onPreviewActive
}) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("trails.table.time"),
      dataIndex: "time",
      key: "time",
      render: (_, trail) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {`${moment(trail.createdAt)
            .utc()
            .format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"}
        </span>
      ),
      width: "25%",
    },
    {
      title: t("trails.table.email"),
      dataIndex: "email",
      key: "email",
      render: (_, trail) => <span>{trail.userEmail || "N/A"}</span>,
      width: "20%",
    },
    {
      title: t("trails.table.updated_from"),
      dataIndex: "updated_from",
      key: "updated_from",
      render: (_, trail) => (
        <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {trail.valueFrom || "N/A"}
        </span>
      ),
      width: "15%",
    },
    {
      title: t("trails.table.updated_to"),
      dataIndex: "updated_to",
      key: "updated_to",
      render: (_, trail) => (
        <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {trail.valueTo || "N/A"}
        </span>
      ),
      width: "15%",
    },
    {
      title: t("trails.table.action"),
      dataIndex: "action",
      key: "action",
      render: (_, trail) => (
        <span style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {trail.action || "N/A"}
        </span>
      ),
      width: "25%",
    },
  ];

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
            margin: "0 32px 16px 0px",
          }}
        >
          <span>{title}</span>
          <Button
            size="large"
            onClick={onPreviewActive}
            style={{marginLeft: 16}}
          >
            {t("trails.preview_active")}
          </Button>
        </div>
      }
      open={isModalOpen}
      onCancel={handleCancel}
      className="plan-page-action-modal"
      footer={null}
      width="75%"
    >
      <div className={classNames("")}>
        <InfinityTable data={logs} hasMore={false} tableColumns={columns} />
      </div>
    </Modal>
  );
};

export default ChangeLogsModalComponent;
